import React from "react";
import Select from "react-select";

const tfOptions = [
	{label: "Anytime", value: ''},
	{label: "Today so far", value: "midnight"},
	{label: "Yesterday", value: "yesterday"},
	{label: "Last 3 days", value: "last3days"},
	{label: "Last 7 days", value: "last7days"},
];

const publishedStoriesOptions = [
	{label: "Today so far", value: "midnight"},
	{label: "Yesterday", value: "yesterday"},
	{label: "Last 3 days", value: "last3days"},
	{label: "Last 7 days", value: "last7days"},
];

type Props = {
	isDisabled?: boolean,
	updateConfig: Function,
	pubDateInterval: string,
	pubDateType?: string
}

type Option = {
	value: string,
	label: string
}

const PubDateTimeWindow = (props: Props) => {
	let timeFrameOptions = props.pubDateType && props.pubDateType === "publishedStories" ? publishedStoriesOptions : tfOptions;

	const getSelectedOption = (key: string, items: Array<Option>) => {
		if (!key) {
			return items.find(item => item.value === '');
		}

		const result = items.find(item => item.value === key);

		if (!result) {
			setTimeout(() => {
				props.updateConfig(['pubdate_interval'], ['']);
			}, 1);
			return items.find(item => item.value === '');
		}

		return result;
	};

	return (
		<div className="form-group">
			<label htmlFor="timeFrameCompared">Publish date</label>
			<Select
				id="pubDateInterval"
				className="basic-single"
				classNamePrefix="so-select-sort"
				isSearchable={true}
				isDisabled={props.isDisabled}
				value={getSelectedOption(props.pubDateInterval, timeFrameOptions)}
				options={timeFrameOptions}
				onChange={e => props.updateConfig(['pubdate_interval'], [e!.value])}
				menuPortalTarget={document.body}
				styles={{menuPortal: base => ({...base, zIndex: 9999})}}
			/>
		</div>
	);
};

export default PubDateTimeWindow;
